import React from 'react';
import PropTypes from 'prop-types';
import cn from './style.module.scss';

export function Option(props) {
  const [opacity, setOpacity] = React.useState(1);

  const className = `${cn.wrapper} ${props.className}`;

  const onDragStart = (event) => {
    removeGhostElements();
    setOpacity(0);
    setCustomGhostElement(event);
    props.onDragStart(event);
  };

  const onDragEnd = () => {
    removeGhostElements();
    setOpacity(1);
  };

  const style = {opacity};

  return (
    <li
      draggable={true}
      style={style}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      className={className}>
      {props.children}
    </li>
  );
}

Option.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * child components
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  /**
   * Callback for onDragStart Event
   */
  onDragStart: PropTypes.func,
};

Option.defaultProps = {
  className: '',
};

const CLONED_ITEM = 'cloned-item';

function setCustomGhostElement(event) {
  const firstChild = event.target.firstChild;
  const ghostElement = firstChild.cloneNode(true);
  ghostElement.id = CLONED_ITEM;
  ghostElement.style = `
    position: absolute;
    top: -5000px;
    width: ${firstChild.offsetWidth}px;
    height: ${firstChild.offsetHeight}px;
  `;
  document.body.appendChild(ghostElement);
  const {offsetX, offsetY} = event.nativeEvent;
  event.dataTransfer.setDragImage(ghostElement, offsetX, offsetY);
}

function removeGhostElements() {
  let ghostElements = [...document.querySelectorAll(`#${CLONED_ITEM}`)];
  while (ghostElements.length) ghostElements.pop().remove();
}
